import "./SparkAnimation.css";

const SparkAnimation = ({ x, y, variant, position }) => {
  return (
    <div className="css-animation-container" data-position={position}>
        <div className={`css-animation-element ${variant}`} />
    </div>
  );
};

export default SparkAnimation;
